import { Injectable } from "@angular/core";
import { BackendApiService } from "./backend-api.service";
import * as moment from "moment";
import { ConvertDatetimePipe } from "../convert-datetime.pipe";
import { MachineUtilizationResponse } from "../../components/client/powertrain-modal/powertrain.model";
import { BehaviorSubject } from "rxjs";
import { BaseUrlConstantsService } from "./base-url-constants.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class PowerTrainService {
  private lastFileProcessed = new BehaviorSubject<string>("");
  public lastFileProcessedObs = this.lastFileProcessed.asObservable();

  private oldDashboardParams = new BehaviorSubject<any>("");
  public oldDashboardParamsObs = this.oldDashboardParams.asObservable();

  private powertrainEditData = new BehaviorSubject<any>(null);
  public powertrainEditDataObs = this.powertrainEditData.asObservable();

  private powertrainSensorsData = new BehaviorSubject<any>(null);
  public powertrainSensorsDataObs = this.powertrainSensorsData.asObservable();

  constructor(private service: BackendApiService, private http: HttpClient) {}

  updateLastFileProcessedTime(time: string) {
    this.lastFileProcessed.next(time);
  }
  updateoldDashboardParams(data: any) {
    this.oldDashboardParams.next(data);
  }
  updatePowertrainEditData(data: any) {
    this.powertrainEditData.next(data);
  }

  setSensors(data) {
    // console.log(data);
    this.powertrainSensorsData.next(data.device_position);
  }

  fetchSensorpositions(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((res) => {
          let sensorpositionsRes = JSON.parse(JSON.stringify(res));
          const { code, status, body } = sensorpositionsRes.data;
          if (code == 200 || status == "success") {
            if (body.data.subsystem_name == undefined) {
              reject({ error: true, message: body.data });
            } else {
              this.setSensors(body.data);
              resolve({
                error: false,
                message: "",
                data: { ...body.data },
              });
            }
          }
        })
        .catch((err) => {
          reject({ error: true, message: "FAILED TO FETCH DATA" });
        });
    });
  }

  fetchSensorsLatestData(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data) => {
          let sensorDataRes = JSON.parse(JSON.stringify(data));
          const { code, status, body } = sensorDataRes.data;
          if (body.sensor == undefined) {
            reject({
              error: true,
              message: "No data found in sensor response",
            });
          }
          let metricData = body.sensor;
          let ultraSound = body.ultrasoundData;
          let newMetricData = metricData.map((metric) => {
            const { value, color, name, key, rangelabel, arcDelimiters } =
              metric;
            let baseValue = +rangelabel[0];
            let maxValue = +rangelabel[1];
            let arcDemlimiter1 = +arcDelimiters[0];
            let arcDemlimiter2 = +arcDelimiters[1];
            let arc1 = ((maxValue - baseValue) * arcDemlimiter1) / 100;
            let arc2 = ((maxValue - baseValue) * arcDemlimiter2) / 100;
            

            if (value >= arc1 && value < arc2) {
              metric.color = "yellow";
            } else if (value >= arc2) {
              metric.color = "red";
            } else {
              metric.color = "green";
            }
            if(name=='Delta Ultrasound'){
              // console.log(metric)
              // console.log(name,value,ultraSound,baseValue,maxValue,arcDemlimiter1,arcDemlimiter2,arc1,arc2)
              if (ultraSound.predicted >= arc1 && ultraSound.predicted < arc2) {
              metric.color = "yellow";
            } else if (ultraSound.predicted >= arc2) {
              metric.color = "red";
            } else {
              metric.color = "green";
            }
            }
            return { key, name, value, color: metric.color };
          });
          newMetricData.push(ultraSound);
          resolve({ newMetricData, ultraSound });
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }

  fetchPerformanceMetrics(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          const { body, code } = data.data;
          if (body) {
            resolve({ ...body, error: false });
          } else {
            reject({ error: true, message: "FAILED TO FETCH DATA" });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ error: true, message: "FAILED TO FETCH DATA" });
        });
    });
  }

  fetchYTDMetricsData(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          if (data.data.status == "success") {
            resolve({ data: data.data.body, error: false });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ error: true, message: "FAILED TO FETCH YTD Data" });
          // this.service.showError("Failed to fetch YTD data");
        });
    });
  }
  fetchYTDMetricsDataV2(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          if (data.data.status == "ok") {
            resolve({ data: data.data.body, error: false });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ error: true, message: "FAILED TO FETCH YTD Data" });
          // this.service.showError("Failed to fetch YTD data");
        });
    });
  }

  updatePerformanceMetrics(endpoint: string, body: any) {
    return new Promise((resolve, reject) => {
      this.service
        .postData(endpoint, body)
        .then((data: any) => {
          const { status, code } = data.data;
          if (code === 200) {
            resolve({ status: "success" });
          } else {
            reject({ status: "fail" });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ status: "fail" });
        });
    });
  }
  updateYTDMetrics(endpoint: string, body: any) {
    return new Promise((resolve, reject) => {
      this.service
        .postData(endpoint, body)
        .then((data: any) => {
          const { status, code } = data.data;
          if (code === 200) {
            resolve({ status: "success" });
          } else {
            reject({ status: "fail" });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ status: "fail" });
        });
    });
  }

  fetchPowertrainAnomalyStatus(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          if (data?.code == 400) {
            this.service.showYellow("No anomaly data found");
            reject({
              status: "fail",
              error: true,
              overall_status: "N/A",
              timeUpdatedAt: "N/A",
              action_required: "N/A",
            });
          }
          const { health_status, lastUpdatedAt } = data;
          let overall_status =
            health_status == "HEALTHY"
              ? "Good"
              : health_status == "UNHEALTHY"
              ? "Unstatisfactory"
              : "Unacceptable";
          let overall_action_required =
            health_status == "HEALTHY"
              ? "No Action Required"
              : health_status == "UNHEALTHY"
              ? "Attention Required"
              : "Immediate Action Required";
          let testDateUtc = moment.utc(lastUpdatedAt);
          let localDate = testDateUtc.local();
          let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
            localDate
          );
          resolve({
            overall_status,
            timeUpdatedAt,
            action_required: overall_action_required,
            error: false,
          });
        })
        .catch((err) => {
          console.log(err);
          // this.service.showError("Failed to fetch anomaly status");
          reject({
            status: "fail",
            error: true,
            overall_status: "N/A",
            timeUpdatedAt: "N/A",
            action_required: "N/A",
          });
        });
    });
  }

  fetchPowertrainUtilization(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((machineUtilRes: MachineUtilizationResponse) => {
          if (
            machineUtilRes.data.status == "success" &&
            machineUtilRes.data.body.device
          ) {
            resolve(machineUtilRes.data.body.device);
          }
          reject({ error: true, message: "Failed to fetch utilization data" });
        })
        .catch((err) => {
          console.log(err);
          // this.service.showError("Failed to fetch powertrain utilization data");
          reject({ error: true, message: "Failed to fetch utilization data" });
        });
    });
  }

  fetchSensorAlerts(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((alertsRes) => {
          resolve(alertsRes);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }

  fetchPowertrainFalseClaims(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((falseClaimsRes: any) => {
          if (falseClaimsRes.data.status == "success") {
            resolve(falseClaimsRes.data.body);
          }
          reject({ error: true, message: "Failed to fetch utilization data" });
        })
        .catch((err) => {
          console.log(err);
          // this.service.showError("Failed to fetch powertrain utilization data");
          reject({ error: true, message: "Failed to fetch utilization data" });
        });
    });
  }

  updateFalseClaimsMetrics(endpoint: string, body: any) {
    return new Promise((resolve, reject) => {
      this.service
        .postData(endpoint, body)
        .then((data: any) => {
          const { status, code } = data.data;
          if (code === 200) {
            resolve({ status: "success" });
          } else {
            reject({ status: "fail" });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ status: "fail" });
        });
    });
  }

  fetchPowertrainHealthBar(endpoint) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          resolve(data.machineHealthData);
          const { status, code } = data.data;
          if (code === 200) {
            resolve({ status: "success" });
          } else {
            reject({ status: "fail" });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ status: "fail" });
        });
    });
  }

  fetchPowertrainImages(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          const { code } = data;
          if (code === 200) {
            resolve({ images: data.body });
          } else {
            reject({ status: "fail" });
          }
        })
        .catch((err) => {
          this.service.showError("Failed to fetch powertrain images");
          reject({ status: "fail" });
        });
    });
  }

  fetchSiteAppname(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          const { body, code, message } = data;
          if (code == 200 || message == "success") {
            resolve(body);
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ error: true, message: "Failed to fetch app name" });
        });
    });
  }
  updateSensorsPosition(endpoint: string, body: any) {
    return new Promise((resolve, reject) => {
      this.service
        .patchDataV2(endpoint, body)
        .then((data: any) => {
          const { code, status } = data.data;
          if (code == 200 && status == "success") {
            resolve({ message: "succcess" });
            this.service.showSuccess("Successfully updated!");
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          reject({ error: true, message: "Failed to fetch app name" });
        });
    });
  }

  deletePowertrain(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .deleteInfo(endpoint)
        .then((data: any) => {
          const { code, status } = data;
          if (code == 200 && status == "success") {
            resolve({ message: "success" });
            this.service.showSuccess("Successfully deleted!");
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to delete powertrain");
          reject({ error: true, message: "Failed to delete powertrain" });
        });
    });
  }

  fetchPhysicalImages(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
  addPhysicalImages(endpoint: string, url) {
    return new Promise((resolve, reject) => {
      this.service
        .postData(endpoint, url)
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
  deletePhysicalImages(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .deleteInfo(endpoint)
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }

  fetchPowertrainTrendsChart(
    subSystemId: string,
    sensorIds: string,
    token: string,
    graphType: number
  ): Promise<any> {
    const url = `${BaseUrlConstantsService.TRENDS_CHART}/${subSystemId}/${sensorIds}?graphType=${graphType}`;
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(url)
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
  updatePtCommissionDate(url:string,subsystem_id: any, start_date: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.service
        .postData(url, { subsystem_id, start_date })
        .then((data: any) => {
          // console.log(data.data);
          const { code, status, body } = data.data;
          if (code == 200 && status == "ok") {
            resolve({ data: body, error: false });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
  toggleOffOFS(url:string,subsystem_id: any, id: any, end_date: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.service
        .putData(url, { id, end_date })
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body, error: false });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
  toggleONOFS(url:string,subsystem_id: any, start_date: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.service
        .postData(url, { subsystem_id, start_date })
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body, error: false });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
  generateReport(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(url)
        .then((data: any) => {
          const { code, status, body } = data.data;
          if (code == 200 && status == "success") {
            resolve({ data: body });
          } else {
            reject({ error: true });
          }
        })
        .catch((err) => {
          console.log(err);
          this.service.showError("Failed to get images");
          reject({ error: true, message: "Failed to fetch images" });
        });
    });
  }
}
